export default __webpack_public_path__ + "static/media/oa_4.e25011fc.mp3";